import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';

const CommunitySignupSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleOpenApp = () => {
    window.open('https://depthme.app', '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="join-waitlist" className="relative py-24 px-6 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <img src="/image2.jpg" alt="" aria-hidden="true" className="w-full h-full object-cover opacity-[0.14]" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/30 via-transparent to-background/30" />
      </div>
      <div className="absolute inset-0 cosmic-gradient opacity-15 pointer-events-none" />

      <div className={`relative z-10 max-w-4xl mx-auto text-center transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}>
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Start your <span className="text-gradient">DepthMe journey</span>
        </h2>

        <p className="text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
          Personalized AI-guided rituals, journaling, and reflection — available now.
        </p>

        <div className="flex justify-center mb-6">
          <Button
            onClick={handleOpenApp}
            variant="default"
            size="lg"
            className="violet-glow text-lg py-4 px-12"
            iconName="ArrowRight"
            iconPosition="right"
          >
            Open the App
          </Button>
        </div>

        {/*
          Community stats — hidden for launch while numbers are still small.
          Re-enable once the waitlist / user count is large enough to be compelling.

          <div className="flex justify-center gap-8 text-muted-foreground mt-8">
            <div>
              <span className="text-2xl font-bold text-primary">{waitlistCount ?? 0}</span>
              <p className="text-sm">People Joined</p>
            </div>
            <div>
              <span className="text-2xl font-bold text-primary">{spotsRemaining ?? 1000}</span>
              <p className="text-sm">Spots Remaining</p>
            </div>
          </div>
        */}
      </div>
    </section>
  );
};

export default CommunitySignupSection;